import React from 'react'
import './App.css'
import { BrowserRouter as Router, Route } from "react-router-dom"
import Squares from './Squares'
import { ExhibitionClient } from '@Pass-It-Down/exhibition-client'

function App() {

  const url = process.env.REACT_APP_SERVER_URL
  const proxyUrl = process.env.REACT_APP_IMG_PROXY_URL
  const api = new ExhibitionClient({ url, proxyUrl })

  return (
      <Router>
        <Route path="/present/:appId/squares" render={(props) =>
          <Squares
          {...props}
          api={api} />} />
    </Router>
  );
}

export default App
